// @flow

import iconRapipagoSrc from './cash-rapipago.svg';
import iconPagofacilSrc from './cash-pagofacil.svg';

export function getSafeBankIconSrc(code: string): string {
  switch (code) {
    case 'rapipago':
      return iconRapipagoSrc;
    case 'pagofacil':
      return iconPagofacilSrc;
    default:
      throw new Error(`BankIcon - there is no source icon for "${code}".`);
  }
}
